import React from 'react'

const Modal = ({modal}) => {

   return (
      <div id="modalBlog" className="modal modal-blog margin-top-modal">
         <div className="modal-content">
            <h4>{modal?.blog_titulo}</h4>
            <p><div dangerouslySetInnerHTML={{__html:modal?.blog_texto}}></div></p>
         </div>
         <div className="modal-footer">
            <a onclick="closeModal()" className="modal-close btn-flat red text-white">Cerrar</a>
         </div>
      </div>
   )
}

export default Modal